<input
  type="range"
  class="slider-input"
  [min]="min()"
  [max]="max()"
  [step]="step()"
  [value]="value()"
  [disabled]="disabled()"
  [attr.aria-label]="ariaLabel()"
  [attr.aria-valuemin]="min()"
  [attr.aria-valuemax]="max()"
  [attr.aria-valuenow]="value()"
  (input)="onInput($event)" />
